import styled from 'styled-components';

export const Container = styled.table`
  width: 100%;
  font-size: 12px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  border-collapse: collapse;
  overflow: hidden;
`;

export const Header = styled.thead`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.textPrimary};

  tr:first-child {
    th {
      text-align: center;
    }
  }

  tr {
    th {
      padding: 5px;
      text-align: left;
    }
  }
`;

export const Body = styled.tbody<{ fechado?: boolean }>`
  transition: 0.2s;
`;
